// @flow

// Terms of Use copy and links for the ParkChicago Fleet admin portal.
//
// CST-13822: CPM has not delivered the final signup wording yet. The message
// constants below hold the previous wording as a placeholder — swapping in the
// final copy should only require editing this file.
//
// TERMS_URL is also consumed by the main navigation (src/App/Navigation.js) so
// that every Fleet-owned Terms of Use link points at a single source of truth.
// Note that the footer link on the Welcome screen is *not* covered by this
// module: its href comes from the shared `termsurl` operator setting, which is
// also read by the ParkChicago consumer apps.

export const TERMS_URL = 'https://parkchicago.com/terms-of-use';

// Shared by the signup dialog anchor, the Welcome footer link, and the Google
// Analytics event switch in src/Auth/Welcome.js. Keeping all three on one
// constant means a copy change cannot silently break analytics.
export const TERMS_LINK_LABEL = 'Terms and Conditions';

export const TERMS_NAV_LABEL = 'Terms of Use';

export const TERMS_MESSAGE_PREFIX = 'You must accept the';
export const TERMS_MESSAGE_SUFFIX =
  ' of the ParkChicago Fleet program before using this application.';

export const TERMS_ACCEPT_LABEL = 'Agree';
export const TERMS_DECLINE_LABEL = 'Decline';



// WEBPACK FOOTER //
// ./src/Auth/Signup/termsCopy.js